var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navbar" }, [
    _c("img", {
      directives: [
        { name: "src", rawName: "v-src", value: _vm.logo, expression: "logo" },
      ],
      key: _vm.logo,
      staticClass: "logo",
      on: { click: _vm.enterCustoemBoard },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "nav-title" }, [_vm._v("\n    系统设置\n  ")]),
    _vm._v(" "),
    _c("div", { staticClass: "back-home", on: { click: _vm.enterHome } }, [
      _vm._v("返回首页"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "go-out", on: { click: _vm.enterLogin } }, [
      _vm._v("退出系统"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }